import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import type { CoreModule } from '../data/modules';
export const ModuleCard = ({
  module: m
}: {
  module: CoreModule;
}) => {
  const [open, setOpen] = useState(false);
  const detailsId = `modulo-${m.num}-detalle`;
  return <article className="bg-familia-lightCard border border-familia-lightBorder p-6 md:p-8 rounded-2xl flex flex-col" data-id="element-137" data-mp="1r4pxqwxz36m4">
      <div className="flex items-center justify-between mb-4" data-id="element-138" data-mp="13e42k692hgtj">
        <span className="text-familia-accent font-mono font-bold text-[14px]" data-id="element-139" data-mp="yfsqrpz7ow8o">
          MÓDULO {m.num}
        </span>
        <span className="text-3xl md:text-4xl" aria-hidden="true" data-id="element-140" data-mp="1d571b1eixjpn">
          {m.icon}
        </span>
      </div>
      <h3 className="text-xl md:text-2xl font-display font-bold text-familia-ink mb-2" data-id="element-141" data-mp="18doys8wurb2k">
        {m.title}
      </h3>
      <p className="text-familia-accent font-bold text-[17px] md:text-[18px] leading-snug" data-id="element-142" data-mp="kn34dkfrtpb1">
        {m.benefit}
      </p>

      {/* Mobile: el detalle se abre con "Ver qué incluye". Desktop: siempre visible. */}
      <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls={detailsId} className="md:hidden mt-4 self-start inline-flex items-center gap-1.5 min-h-[44px] text-[16px] font-bold text-familia-ink underline underline-offset-4 decoration-familia-lightBorder" data-id="element-143" data-mp="2fyuvdab17lg1">
        Ver qué incluye
        <ChevronDownIcon className={`w-4 h-4 transition-transform duration-200 ease-out ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-144" data-mp="2tsvljfnx404s" />
      </button>

      <div id={detailsId} className={`${open ? 'flex' : 'hidden'} md:flex flex-col flex-grow mt-4`} data-id="element-145" data-mp="21ytmp8oiz9q0">
        <p className="text-familia-inkMuted text-[14px] font-semibold uppercase tracking-wide mb-4" data-id="element-146" data-mp="2605d3gf83yz9">
          {m.subtitle}
        </p>
        <p className="text-body text-familia-inkMuted mb-6" data-id="element-147" data-mp="2b1kvf0q0nrdy">{m.desc}</p>
        <div className="border-t border-familia-lightBorder pt-4 mt-auto" data-id="element-148" data-mp="3hfk84envggrq">
          <p className="text-[14px] font-bold text-familia-ink uppercase tracking-wider mb-3" data-id="element-149" data-mp="3mex3jnst6w5x">
            Incluye:
          </p>
          <ul className="space-y-2" data-id="element-150" data-mp="1mbw2n2n81k31">
            {m.includes.map(item => <li key={item} className="flex items-start gap-2 text-[16px] text-familia-inkMuted leading-snug" data-id="element-151" data-mp="1ic5061oc1fio">
                <span className="text-familia-accent shrink-0" aria-hidden="true" data-id="element-152" data-mp="1wbmvkzw4vr10">
                  →
                </span>
                <span data-id="element-153" data-mp="1rctgx4541tz9">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </article>;
};